<template>
  <v-app class="us-v-app">
    <v-app-bar color="blue-grey" dense dark app>
      <v-btn icon @click="goBack">
        <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title style="font-size:1rem;">帮助登录电脑端</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <v-container style="font-size:0.85rem;padding-bottom:3rem;">
        <div style="margin-top:0.8rem;">1. 先绑定手机号码</div>
        <div style="margin-top:0.8rem;text-align:center;"><img src="/res/help/HelpLoginPc/1.png" style="width:80%;height:80%;" /></div>
        <div style="margin-top:1.5rem;">2. 访问地址登录</div>
        <div style="margin-top:0.5rem;">地址：http://ops.gz7x24.cn/</div>
        <div style="margin-top:0.5rem;">账号：手机号码，默认密码：123</div>
        <div style="margin-top:0.8rem;"><img src="/res/help/HelpLoginPc/2.png" style="width:100%;height:100%;" /></div>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {}
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    goBack() {
      this.$router.goBack()
    }
  }
}
</script>

<style scoped>
.us_list_item{
  min-height:2.6rem;
  max-height:3rem;
  padding-right:0.15rem;
  padding-left:1.5rem;
}
</style>

